import { escapeHtml } from "./utils";
export function updatePageTitle(titleText) { const titleElement = document.querySelector('.content-heading__title'); if (titleElement)
    titleElement.innerHTML = escapeHtml(titleText); }
